<template>
	<div>
		<div class="flex align-center typeop">
			<p class="shipin pointer" @click="chose(0)" :class="typindex == 0?'active':''">视频课程</p>
			<p class="wenjian pointer" @click="chose(1)" :class="typindex == 1?'active':''">文件课程</p>
		</div>
		<el-row :gutter="20">
			<el-col :span="12" v-for="(item,index) in list" :key="index">
				<div class="flex bg-white list-item margin-bottom-sm" @click="godetail()">
					<img class="cover margin-right-sm" :src="item.course.logo" >
					<div class="text-left flex flex-sub flex-direction justify-between">
						<p class="titlw" :style="[{ fontSize:size+'px'}]">{{item.course.title}}</p>
						<!-- <p class="text-sm text-666">课程章节：共{{item.course.chapterCount}}节</p> -->
						<div class="flex align-center justify-between">
							<p class="text-price fs24 text-bold text-prices" v-if="item.course.price != 0">{{item.course.price}}</p>
							<p class="text-bf text-bold text-prices" v-if="item.course.price == 0">免费</p>
							<div class="flex align-center justify-between pointer" @click.stop="del(item)">
								<i class="el-icon-error text-lg text-theme"></i>
								<p class="text-sm text-theme">取消收藏</p>
							</div>
						</div>
						
					</div>
				</div>
			</el-col>
		</el-row>
		
	</div>
</template>

<script>
	export default {
		components: {
			
		},
		data() {
			return {
				typindex:0,//类型  0 视频   1 文件
				page:1,
				list:[]
			};
		},
		created() {
			console.log('---------');
			this.getlist()
		},
		methods: {
			//选择类型  0 视频   1 文件
			chose(index){
				this.typindex = index
				this.page = 1
				this.getlist()
			},
			//去详情
			godetail(){
				this.$router.push({
					name:'skillDetail',
					query: {
						id:1
					}
				})
			},
			getlist(){
				this.ajax('get', '/api/pc/collection/getList', {
					stat:2,
					page:this.page,
					type:this.typindex
				}, res => {
					console.log(res);
					if(res.status == 200){
						this.list = res.data.data
					}else{
						this.$message(res.msg);
					}
				})
			},
			del(item){
				this.ajax('post', '/api/collection/add', {
					type_id:item.type_id,
					type:2
				}, res => {
					this.$message(res.msg);
					if(res.status == 200){
						this.getlist()
					}else{
						
					}
				})
				
			}
		}
	}
</script>

<style scoped lang="less">
	.typeop{
		box-shadow: 2px 3px 29px 1px rgba(201,199,199,0.3);
		width: 170px;
		margin: 0 auto 20px;
		p{
			width: 85px;
			height: 38px;
			line-height: 38px;
			background: #FFFFFF;
		}
		.shipin{
			border-radius: 10px 0px 0px 10px;
		}
		.wenjian{
			border-radius: 0px 10px 10px 0px;
		}
		.active{
			background: #36908B;
			color: #fff;
		}
	}
	.list-item{
		padding: 24px;
		border-radius: 20px;
	}
	.cover{
		width: 104px;
		height: 133px;
	}
	.fs24{
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/collect/course.vue